// src/Component/Toast/ErrorToast.js
import AppToast from './AppToast';

const ErrorToast = (props) => <AppToast type="error" delay={1} {...props} />;
export default ErrorToast;